/* eslint-disable sort-keys, max-len */
const { flattenMessages } = require('@/utils/flattenMessages');
export default {
    en: flattenMessages(require('./en.ts').default),
    'en-gb': flattenMessages(require('./en-gb.ts').default),
    de: flattenMessages(require('./de.ts').default),
    es: flattenMessages(require('./es.ts').default),
    fr: flattenMessages(require('./fr.ts').default),
    it: flattenMessages(require('./it.ts').default),
    ja: flattenMessages(require('./ja.ts').default),
    ko: flattenMessages(require('./ko.ts').default),
    nl: flattenMessages(require('./nl.ts').default),
    pl: flattenMessages(require('./pl.ts').default),
    ru: flattenMessages(require('./ru.ts').default),
    zh: flattenMessages(require('./zh.ts').default),
} as const;
